import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'sandcastleWall',
      d: 'M-1,-2.5h3v0.5h-3zM-2,-2h4.5v0.5h-4.5zM3.5,-2h0.5v0.5h-0.5zM-4.5,-1.5h1v0.5h-1zM-2.5,-1.5h5v0.5h-5zM3.5,-1.5h2v0.5h-2zM-5.5,-1h2v0.5h-2zM-2,-1h1.5v0.5h-1.5zM4,-1h2v0.5h-2zM-6,-0.5h2v0.5h-2zM4.5,-0.5h1.5v1h-1.5zM-6,0h1.5v0.5h-1.5zM-6,0.5h2v0.5h-2zM4,0.5h2v0.5h-2zM-5.5,1h2.5v0.5h-2.5zM3,1h3v0.5h-3zM-5,1.5h5.5v0.5h-5.5zM1,1.5h4.5v0.5h-4.5zM-4,2h8.5v0.5h-8.5zM-0.5,2.5h2v0.5h-2z',
    },
    {
      paint: 'water',
      d: 'M-2.5,-1h0.5v0.5h-0.5zM-0.5,-1h3v0.5h-3zM3.5,-1h0.5v0.5h-0.5zM-4,-0.5h0.5v0.5h-0.5zM-2.5,-0.5h3.5v0.5h-3.5zM3.5,-0.5h1v0.5h-1zM-4.5,0h1v0.5h-1zM2.5,0h2v0.5h-2zM-4,0.5h2.5v0.5h-2.5zM2.5,0.5h1.5v0.5h-1.5zM-3,1h6v0.5h-6zM0.5,1.5h0.5v0.5h-0.5z',
    },
    { paint: 'epicCrystal', d: 'M1,-0.5h1.5v0.5h-1.5zM-2.5,0h5v0.5h-5zM-1.5,0.5h4v0.5h-4z' },
    {
      paint: 'trunk',
      d: 'M-3,-5.5h0.5v0.5h-0.5zM-3.5,-5h1v0.5h-1zM-3.5,-4.5h1.5v0.5h-1.5zM3,-4.5h0.5v0.5h-0.5zM-3,-4h1v0.5h-1zM2.5,-4h1v2h-1zM-2.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h1.5v1.5h-1.5zM2.5,-2h0.5v0.5h-0.5zM-3,-1.5h0.5v0.5h-0.5zM2.5,-1.5h1v1.5h-1zM-3.5,-1h1v1.5h-1z',
    },
    {
      paint: 'palm',
      d: 'M-6,-6.5h3v0.5h-3zM-1.5,-6.5h1v0.5h-1zM-6,-6h6v0.5h-6zM1,-6h1.5v0.5h-1.5zM-6.5,-5.5h3.5v0.5h-3.5zM-2.5,-5.5h1v0.5h-1zM-1,-5.5h1v0.5h-1zM0.5,-5.5h2.5v0.5h-2.5zM4,-5.5h2v0.5h-2zM-6.5,-5h0.5v0.5h-0.5zM-5,-5h1.5v0.5h-1.5zM-2.5,-5h1.5v0.5h-1.5zM0,-5h6v0.5h-6zM-5.5,-4.5h1.5v0.5h-1.5zM-2,-4.5h1.5v0.5h-1.5zM2,-4.5h1v0.5h-1zM3.5,-4.5h1.5v0.5h-1.5zM-5.5,-4h1v0.5h-1zM-1.5,-4h1v0.5h-1zM1.5,-4h1v0.5h-1zM4,-4h1v0.5h-1zM4.5,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-3.5,-8h1v0.5h-1zM-3.5,-7.5h1.5v0.5h-1.5zM-1.5,-7.5h2v0.5h-2zM-3.5,-7h4v0.5h-4zM-3,-6.5h1.5v0.5h-1.5zM3.5,-6.5h1.5v0.5h-1.5zM3.5,-6h1v0.5h-1zM3,-5.5h1v0.5h-1z',
    },
    { paint: 'wheat', d: 'M-3,-3.5h0.5v0.5h-0.5zM3,-2h0.5v0.5h-0.5zM-3.5,-1.5h0.5v0.5h-0.5z' },
  ],
  pixels: 335,
};
export const sprites: readonly PixelSprite[] = [variant0];
